import { PASS_BREACH_SUCCESS, PASS_BREACH_IS_LOADING, PASS_BREACH_HAS_ERRORED } from './types';
import { FEED_URLSRC_PASS_BREACH, PASSWORD_MIN_CHARACTERS } from '../constants'
import { globalFetch } from './globalActions';
import CryptoJS from 'crypto-js';

////////////////////////
// PASSWORD PWNED VERIFICATION - form zxcvbn //
////////////////////////

export const initState = {
    foundLine: false,
    occurrences: 0,
    prefix: '',
    suffix: '',
    data: ''
};

async function sha1(value) {
    return CryptoJS.SHA1(value).toString(CryptoJS.enc.Hex);
}

export function clearPassBreached() {
    return function(dispatch) {
        dispatch({ type: PASS_BREACH_SUCCESS, item: initState}); 
    }
}

export async function setPassBreach(value) {
    if(value && value.length >= PASSWORD_MIN_CHARACTERS) {

        // Hash the password using SHA-1
        const hashedPassword = await sha1(value);
        // Use only the first 5 characters of the hashed password (prefix)
        const prefix = hashedPassword.slice(0, 5).toUpperCase();
        // Remaining part of the hashed password (suffix)
        const suffix = hashedPassword.slice(5).toUpperCase();

        return globalFetch({
            urlSrc: FEED_URLSRC_PASS_BREACH,
            extraParams: prefix,
            reducerIsLoading: PASS_BREACH_IS_LOADING,
            reducerError: PASS_BREACH_HAS_ERRORED,
            dispatchSuccess: (itemObj, dispatch) => {
                dispatch(setPassBreachSuccess(itemObj, prefix, suffix));
            }
        });

    } else {
        return {
            type: PASS_BREACH_SUCCESS,
            payload: initState,
        };
    }
}

export function setPassBreachSuccess(text, prefix, suffix) {
    // Check if the suffix is in the list of compromised passwords
    const lines = text.split('\n').map(line => line.trim());
    const foundLine = lines.find(line => line.startsWith(suffix));
    const occurrences = foundLine ? parseInt(foundLine.split(':')[1], 10) : 0;

    let result = {
        foundLine: !!foundLine,
        occurrences,
        prefix,
        suffix,
        data: text
    };

    return {
        type: PASS_BREACH_SUCCESS,
        payload: result,
    };
  }